module.exports = __webpack_public_path__ + "img/incore-bank-ag.ca73faa.svg";